import React, { useContext, useEffect, useState } from 'react';
import { Form, Tabs, Col, Row, notification, Popconfirm, Spin } from 'antd';
import AssetCatalogCriteriaTable from './AssetCatalogCriteriaTable';
import {
  dateToString,
  objectLabelToString,
  objectParValueToString,
  shouldUpdateCompare,
  toDatePickerDate,
} from 'utils/utils2';
import AssetCatalogLabelsTable from './AssetCatalogLabelsTable';
import AssetCatalogServicesTable from './AssetCatalogServicesTable';
import AssetCatalogComponentsTable from './AssetCatalogComponentsTable';
import AssetCatalogOptionsTable from './AssetCatalogOptionsTable';
import AssetCatalogPicturessTable from './AssetCatalogPicturesTable';
import {
  // AssetCatalogResponse,
  createAssetCatalog,
  duplicateAssetCatalog,
  getAssetCatalogByID,
  updateAssetCatalog,
  ViewEntityAddAttributeResponse,
} from 'services/assetconfig';
import { useHistory, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import GetLabel from 'DisplayFramework/components/GetLabel';
import DF from 'DisplayFramework';
import TabAssetGeneralData from './AssetCatalogGeneralData';
import SaveButton from 'components/SaveButtonTabsTop';
import { ArrowLeftOutlined } from '@ant-design/icons';
import moment from 'moment';
import AssetCatalogRVList from './AssetCatalogRVListTable';
import AssetCatalogAutoDescTable from './AssetCatalogAutoDescTable';
import AssetUseList from './AssetUseList';
import AssetFutureValueList from './AssetFutureValueList';
import TasksListPopover from 'pages/workflow/TasksListPopover';
import Button from 'components/Button';
import IActions from 'icons/IActions';
import { isBoolean, isNil, isNumber } from 'lodash';
import { EntityAdditionalAttributeRequest } from 'services/assets';
import { useAttributeContextFramework } from 'DisplayFramework/hooks/useAttribute';
import { onFinishFailed } from 'components/DisplayValidationErrors/DisplayValidationErrors';
import AssetCatalogUpdgrades from './AssetCatalogUpgrades';
import ProcessFollowUp from 'components/ProcessFollowUp';
import DuplicateButtonAction from 'components/DuplicatButtonAction';
import { AuthContext } from 'components/Auth/Auth';
import AssetCatalogAuthCompanies from './AssetCatalogAuthorizedCompanies';
import { getMyWizards } from 'services/workflow';
import { useForm } from 'antd/lib/form/Form';

const { TabPane } = Tabs;

type AssetCatalogDetailProps = {
  visible?: boolean;
  onCancel?: () => void;
  catalogid: number;
  isModal?: string;
};

const AssetCatalogDetail = (props: AssetCatalogDetailProps) => {
  const { catalogid, isModal } = props;
  const history = useHistory();
  const [form] = useForm();
  // eslint-disable-next-line no-unused-vars
  const [activeKey, setActiveKey] = useState('1');
  const { idOrCreate, duplicate } = useParams<{
    idOrCreate: string;
    duplicate: string;
  }>();
  const isCreate = idOrCreate === 'create' || idOrCreate === 'new';
  const isNew = idOrCreate === 'new' || duplicate === 'catalog';

  const isDuplicate = duplicate === 'duplicate';
  const id = !isCreate ? idOrCreate : undefined;

  const [loading, setLoading] = useState(false);

  const getid = () => {
    return catalogid ? catalogid : Number(id);
  };
  const {
    data: catalog,
    refetch,
    isFetching,
  } = useQuery(['getAssetCatalogByID', getid()], () =>
    getAssetCatalogByID({
      catalogid: getid(),
    }).then((res) => res.data)
  );
  const [ismultiple, setIsmultiple] = useState(false);
  const setmulti = (multi: any) => {
    setIsmultiple(multi);
  };
  const { isInspect } = useContext(AuthContext);

  const [state, setState] = useState({
    attid: 0,
    assetsegment: { value: '', label: '' },
    assetfamily: { value: '', label: '' },
    assettype: { value: '', label: '' },
    assetcategory: { value: '', label: '' },
    assetmodel: { value: '', label: '' },
  });

  const { data: attlist } = useAttributeContextFramework(
    'ASSET',
    'CATALOG',
    '',
    '',
    state.assetfamily.value ?? '',
    state.assettype?.value ?? '',
    state.assetcategory?.value ?? '',
    state.assetsegment?.value ?? '',
    state.assetmodel?.value ?? ''
  );

  useEffect(() => {
    isModal && refetch();
    if (catalog) {
      form.setFieldsValue({
        ...catalog,
        manufacturer: {
          tpid: catalog.tpidmanufacturer,
          tpreference: catalog.manufacturerreference,
          tpname: catalog.manufacturername,
        },
        supplier: {
          tpid: catalog.tpidsupplier,
          tpreference: catalog.supplierreference,
          tpname: catalog.suppliername,
        },
        broker: {
          tpid: catalog.tpidbroker,
          tpreference: catalog.brokerreference,
          tpname: catalog.brokername,
        },
        deliverydelay: catalog.deliverydelay,
        catalogid: isDuplicate ? null : catalog.catalogid,
        startdate: toDatePickerDate(catalog.startdate),
        enddate: toDatePickerDate(catalog.enddate),
        assetcategory: {
          value: catalog.assetcategory,
          label: catalog.assetcategorylabel,
        },
        assetfamily: {
          value: catalog.assetfamily,
          label: catalog.assetfamilylabel,
        },
        assetcategorylabel: catalog.assetcategorylabel,
        assetconstructor: catalog.assetconstructor,
        assetconstructorreference: catalog.assetconstructorreference,
        assetdescription: catalog.assetdescription,
        assetdiscountamount: catalog.assetdiscountamount,
        assetdiscountperc: catalog.assetdiscountperc,
        assetgrossamount: catalog.assetgrossamount,
        assetgrossamountorigine: catalog.assetgrossamountorigine,
        assetlabel: catalog.assetlabel,
        assetmodel: {
          value: catalog?.assetmodel,
          label: catalog?.assetmodellabel,
        },
        assetmulticomponents: catalog.assetmulticomponents,
        assetnetamount: catalog.assetnetamount,
        assetnetamountorigine: catalog.assetnetamountorigine,
        assetpictureurl: catalog.assetpictureurl,
        assetpictureurl2: catalog.assetpictureurl2,
        assetpictureurl3: catalog.assetpictureurl3,
        assetpictureurl4: catalog.assetpictureurl4,
        assetpictureurl5: catalog.assetpictureurl5,
        assetpictureurl6: catalog.assetpictureurl6,
        assetstatuslabel: catalog.assetstatuslabel,
        assettaxamount: catalog.assettaxamount,
        assettype: { value: catalog.assettype, label: catalog.assettypelabel },
        assettypelabel: catalog.assettypelabel,
        assetvariant: catalog.assetvariant,
        catalogstatus: catalog.catalogstatus,
        flagwebshop: catalog.flagwebshop,
        mcid: catalog.mcid,
        mclabel: catalog.mclabel,
        markeCompain: { mcid: catalog.mcid, mclabel: catalog.mclabel },
        mgid: catalog.mgid,
        networkcode: catalog.networkcode,
        suppliername: catalog.suppliername,
        assetversion: catalog?.assetversion,
        taxcode: catalog.taxcode,
        taxrate: catalog.taxrate,
        tpidbroker: catalog.tpidbroker,
        tpidsupplier: catalog.tpidsupplier,
        brokername: catalog.brokername,
        brokerreference: catalog.brokerreference,
        supplierreference: catalog.supplierreference,
        tpidmanufacturer: catalog.tpidmanufacturer,
        manufacturerreference: catalog.manufacturerreference,
        manufacturername: catalog.manufacturername,

        currcode: catalog.currcode,
        assetfamilylabel: catalog.assetfamilylabel,

        assetsegment: {
          value: catalog.assetsegment,
          label: catalog.assetsegmentlabel,
        },
        assetsegmentlabel: catalog.assetsegmentlabel,
        flagholdback: catalog.flagholdback,
        holdbackpercentage: catalog.holdbackpercentage,
        holdbackamount: catalog.holdbackamount,
        holdbackbeleasenbdays: catalog.holdbackbeleasenbdays,
        holdbackbeleasedate: catalog.holdbackbeleasedate,
        kwhpower: catalog.kwhpower,
        kwhproduction: catalog.kwhproduction,
        kwhdegradation: catalog.kwhdegradation,
        degfeesformula: catalog.degfeesformula,
        spfeesformula: catalog.spfeesformula,
        tpofformula: catalog.tpofformula,
        age: catalog.age,
        balersize: catalog.balersize,
        separatortype: catalog.separatortype,
        wheeldrive: catalog.wheeldrive,
        transmission: catalog.transmission,
        wheeltrack: catalog.wheeltrack,
        lift: catalog.lift,
        capacity: catalog.capacity,
        tankcapacity: catalog.tankcapacity,
        nbcampaign: catalog.nbcampaign,
        threshinghours: catalog.threshinghours,
        rotorhours: catalog.rotorhours,
        totalhours: catalog.totalhours,
        totalbalers: catalog.totalbalers,
        country: catalog.country,
      });
      setIsmultiple(catalog.assetmulticomponents);
      setState({
        attid: 0,
        assetsegment: {
          value: catalog.assetsegment,
          label: catalog.assetsegmentlabel,
        },
        assetfamily: {
          value: catalog?.assetfamily,
          label: catalog.assetfamilylabel,
        },
        assettype: { value: catalog.assettype, label: catalog.assettypelabel },
        assetmodel: {
          value: catalog.assetmodel,
          label: catalog.assetmodellabel,
        },

        assetcategory: {
          value: catalog?.assetcategory,
          label: catalog?.assetcategorylabel,
        },
      });
      if (!isNil(catalog?.entityAddAttributList)) {
        let test = {};

        catalog?.entityAddAttributList?.forEach(
          (att: ViewEntityAddAttributeResponse) => {
            let value: any;

            if (att.attdatatype === 'STRING') {
              value = att.attstringvalue;
            } else if (att.attdatatype === 'LONG') {
              value = att.attnumericvalue;
            } else if (att.attdatatype === 'DOUBLE') {
              value = att.attnumericvalue;
            } else if (att.attdatatype === 'BOOLEAN') {
              value = att.attbooleanvalue;
            } else if (att.attdatatype === 'TEXT') {
              value = att.atttextvalue;
            } else if (att.attdatatype === 'DATE') {
              value = toDatePickerDate(att.atttextvalue);
            }

            let obj = { [att.attcode]: value };
            test = { ...test, ...obj };
          }
        );
        form.setFieldValue('entityAddAttributList', test);
      }
    } else {
      let manufacturer;
      manufacturer = JSON.parse(localStorage?.getItem('manufacturer') ?? '{}');
      form.setFieldsValue({
        mgid: Number(localStorage.getItem('mgid')),
        startdate: moment(new Date(), 'YYYY-MM-DD'),
        manufacturer: {
          tpid: manufacturer?.tpid ?? 0,
          tpreference: manufacturer?.tprefrence ?? '',
          tpname: manufacturer?.tpname ?? '',
        },
      });
    }
  }, [form, isDuplicate, catalog, isNew, refetch]);
  const { data: wizData } = useQuery(['getMyWizards'], () =>
    getMyWizards({
      entity: 'CATALOG',
    }).then((res) => res.data)
  );
  const onFinish = (values: any) => {
    form
      .validateFields()
      .then((values) => {
        setLoading(true);
        const startdate = form.getFieldValue('startdate');
        const enddate = form.getFieldValue('enddate');

        let entityAddAttribut = form.getFieldValue('entityAddAttributList');

        let entityAddAttributassets: any = attlist?.map(
          (att: any) => att?.attcode
        );

        let entityAddAttributList: EntityAdditionalAttributeRequest[] = [];

        if (entityAddAttribut !== undefined && entityAddAttribut !== null) {
          Object.keys(entityAddAttribut)?.forEach(function (key, index) {
            if (
              !isNil(entityAddAttributassets) &&
              entityAddAttributassets.length > 0 &&
              entityAddAttributassets.includes(key)
            ) {
              let attnumericvalue: number = 0;
              let atttextvalue: string = '';
              let attbooleanvalue = null;
              let attstringvalue: string = '';
              if (isBoolean(entityAddAttribut[key])) {
                attbooleanvalue = Boolean(entityAddAttribut[key]);
              } else if (isNumber(entityAddAttribut[key])) {
                attnumericvalue = Number(entityAddAttribut[key]);
              } else if (String(entityAddAttribut[key]).length < 100) {
                attstringvalue = entityAddAttribut[key];
                atttextvalue = entityAddAttribut[key];
              } else {
                atttextvalue = entityAddAttribut[key];
              }

              let entityAddAttributData: EntityAdditionalAttributeRequest = {
                attbooleanvalue: attbooleanvalue ?? false,
                attcode: key,
                attnumericvalue: attnumericvalue,
                attstringvalue: attstringvalue,
                atttextvalue: atttextvalue,
                entity: 'CATALOG',
                entityid: Number(id),
                id: 0,
              };
              entityAddAttributList.push(entityAddAttributData);
            }
          });
        }
        const data = {
          ...values,
          last_action:
            isCreate || isDuplicate
              ? wizData?.taskidCreate
              : wizData?.taskidUpdate ?? 0,
          assetsegment:
            objectParValueToString(values.assetsegment) ??
            objectParValueToString(form.getFieldValue('assetsegment')),
          assettype:
            objectParValueToString(values.assettype) ??
            objectParValueToString(form.getFieldValue('assettype')),
          assetfamily:
            objectParValueToString(values.assetfamily) ??
            objectParValueToString(form.getFieldValue('assetfamily')),
          assetmodel:
            objectParValueToString(values.assetmodel) ??
            objectParValueToString(form.getFieldValue('assetmodel')),
          assetmodellabel:
            objectLabelToString(values.assetmodel) ??
            objectLabelToString(form.getFieldValue('assetmodellabel')),
          assetcategory:
            objectParValueToString(values.assetcategory) ??
            objectParValueToString(form.getFieldValue('assetcategory')),
          assetCatalogComponents:
            form.getFieldValue('assetCatalogComponents') ?? [],
          assettypelabel:
            objectLabelToString(values.assettype) ??
            objectLabelToString(form.getFieldValue('assettypelabel')),
          assetcategorylabel:
            objectLabelToString(values.assetcategory) ??
            objectLabelToString(form.getFieldValue('assetcategorylabel')),
          assetpictureurl:
            objectLabelToString(values?.assetpictureurl) ??
            objectLabelToString(form.getFieldValue('assetpictureurl')),
          assetvariant: values?.assetvariant,
          assetversion: values?.assetversion,

          tpidsupplier: values.supplier?.tpid,
          suppliername: values.supplier?.tpname,
          supplierreference: values.supplier?.tpreference,

          tpidmanufacturer: values.manufacturer?.tpid,
          manufacturername: values.manufacturer?.tpname,
          manufacturerreference: values.manufacturer?.tpreference,

          catalogid: isNaN(Number(id)) ? null : Number(id),
          startdate: dateToString(startdate),
          enddate: enddate ? dateToString(enddate) : '',
          tpidbroker: values?.broker?.tpid,
          degfeesformula:
            typeof values.degfeesformula === 'object'
              ? values.degfeesformula?.priid
              : values.degfeesformula,
          spfeesformula:
            typeof values.spfeesformula === 'object'
              ? values.spfeesformula?.priid
              : values.spfeesformula,
          tpofformula:
            typeof values.tpofformula === 'object'
              ? values.tpofformula?.priid
              : values.tpofformula,
          mcid: values?.markeCompain?.mcid,
          entityAddAttributList: entityAddAttributList ?? [],
        };
        if (isCreate || isDuplicate) {
          return createAssetCatalog({
            req: { ...data, catalogstatus: 'INIT' },
          })
            .then((response) => {
              if (response.code === '200') {
                notification.success({
                  description: response.description,
                  message: response.message,
                });
                history.push(
                  `/configuration/asset-catalog/${response.data.catalogid}`
                );
                setLoading(false);
              }
            })
            .catch(() => {
              setLoading(false);
            });
        } else {
          setLoading(true);
          return updateAssetCatalog({
            req: { ...data, last_action: wizData?.taskidUpdate },
          })
            .then((response) => {
              setLoading(false);
              if (response.code === '200') {
                notification.success({
                  description: response.description,
                  message: response.message,
                });
                history.push(
                  `/configuration/asset-catalog/${response.data.catalogid}`
                );
              }
            })
            .catch(() => {
              setLoading(false);
            });
        }
      })
      .catch((e) => {
        onFinishFailed(e);
      });
  };


  return (
    <DF.Provider
      pagcode="assetcataloddetail"
      additionalAttribute={{
        entity: 'ASSET',
        object: 'CATALOG',
        assetfamily: state.assetfamily?.value ?? '',
        assettype: state.assettype?.value ?? '',
        assetcategory: state.assetcategory?.value ?? '',
        assetsegment: state.assetsegment?.value ?? '',
        assetmodel: state.assetmodel?.value ?? '',
      }}
    >
      <Spin spinning={isFetching}>
        <Form
          form={form}
          labelCol={{ span: 16 }}
          wrapperCol={{ span: 16 }}
          initialValues={INITIAL_VALUES}
          layout="vertical"
          // onFinish={onFinish}
          onSubmitCapture={onFinish}
          onFinishFailed={(errorInfo: any) => {
            onFinishFailed(errorInfo);
          }}
        >
          <div className="card-container">
            <Row>
          <Col span={isInspect ? 8 : 13}>
            {!isCreate ? (
              <Row style={{ paddingTop: 3, paddingBottom: 3 }}>
                <b>
                  {form.getFieldValue('catalogid') +
                    ' - ' +
                    form.getFieldValue('assetlabel')}
                </b>
              </Row>
            ) : (
              <Row style={{ paddingTop: 3, paddingBottom: 3 }}>
                <b>
                  New Asset Catalog
                </b>
              </Row>
            )}
            </Col>
            <Col span={isInspect ? 16 : 11}>
            <div style={{float:"right"}}> 
      {!isModal && (
        <Row>
          {catalog && (
            <>
              <Col span={5}>
                <TasksListPopover
                  entityId={Number(catalog.catalogid)}
                  entityReference={'ID : ' + catalog?.catalogid}
                  entityName="CATALOG"
                  title={catalog?.catalogid + ' - ' + catalog?.assetlabel}
                  onClose={() => {
                    refetch();
                  }}
                >
                  <Button
                    comcode="actions"
                    style={{ height: 40, width: '100%' }}
                    icon={<IActions />}
                  />
                </TasksListPopover>
              </Col>
              <Popconfirm
                title="Sure to duplicate?"
                onConfirm={() => {
                  !isInspect &&
                    duplicateAssetCatalog({
                      catalogid: form.getFieldValue('catalogid'),
                      catalogidorigine: 0,
                      isnewVersion: false,
                    }).then((res) => {
                      history.push(
                        `/configuration/asset-catalog/${res.data.catalogid}`
                      );
                      notification.success({ message: res.message });
                      refetch();
                    });
                }}
              >
                <DuplicateButtonAction comcode="duplicate" size="large" />
              </Popconfirm>
              <Popconfirm
                title="Sure to create a new version ?"
                onConfirm={() => {
                  !isInspect &&
                    duplicateAssetCatalog({
                      catalogid: form.getFieldValue('catalogid'),
                      catalogidorigine:
                        form.getFieldValue('catalogidorigine') ??
                        form.getFieldValue('catalogid'),
                      isnewVersion: true,
                    }).then((res) => {
                      history.push(
                        `/configuration/asset-catalog/${res.data.catalogid}`
                      );
                      notification.success({ message: res.message });
                      refetch();
                    });
                }}
              >
                <DuplicateButtonAction
                  comcode="newVersion"
                  size="large"
                  newVersion
                />
              </Popconfirm>
            </>
          )}
          <Col span={4}>
            <SaveButton
              comcode={isCreate ? 'save' : 'update'}
              loading={loading}
            />
          </Col>
        </Row>
      )}
    </div>
            </Col>
            </Row>
            <Form.Item
              shouldUpdate={shouldUpdateCompare('assetfamily')}
              noStyle
            >
              {({ getFieldValue }) => (
                <Tabs
                  onChange={(activeKey) => setActiveKey(activeKey)}
                  tabPosition="top"
                  type="card"
                  animated
                >
                  <TabPane
                    tab={
                      <>
                        {!isModal && (
                          <ArrowLeftOutlined
                            onClick={() => {
                              isNew
                                ? history.push(`/mycatalog`)
                                : history.push(`/configuration/asset-catalog`);
                            }}
                          />
                        )}
                        <GetLabel label="generalData" />
                      </>
                    }
                    key="1"
                  >
                    <TabAssetGeneralData
                      form={form}
                      setIsmulti={setmulti}
                      setState={setState}
                      state={state}
                      catalogid={Number(id)}
                      refetch={refetch}
                    />
                  </TabPane>
                  <TabPane
                    tab={<GetLabel label="components" />}
                    key="2"
                    disabled={!ismultiple}
                  >
                    <AssetCatalogComponentsTable
                      form={form}
                      currcode={form.getFieldValue('currcode')}
                    />
                  </TabPane>

                  <TabPane tab={<GetLabel label="autoDescription" />} key="3">
                    <AssetCatalogAutoDescTable state={state} form={form} />
                  </TabPane>

                  {!isCreate && (
                    <>
                      <TabPane tab={<GetLabel label="criteria" />} key="4">
                        <AssetCatalogCriteriaTable
                          asset={catalog ?? ([] as any)}
                          isModal={isModal ? isModal : ''}
                        />
                      </TabPane>
                      <TabPane tab={<GetLabel label="options" />} key="5">
                        <AssetCatalogOptionsTable
                          asset={catalog ?? ([] as any)}
                          isModal={isModal ? isModal : ''}
                          objectreference=""
                        />
                      </TabPane>
                      <TabPane tab={<GetLabel label="upgrades" />} key="6">
                        <AssetCatalogUpdgrades
                          catalogid={Number(id)}
                          isModal={isModal ? isModal : ''}
                          data={catalog ?? ([] as any)}
                          refetch={refetch}
                        />
                      </TabPane>
                      <TabPane tab={<GetLabel label="services" />} key="7">
                        <AssetCatalogServicesTable
                          asset={catalog ?? ([] as any)}
                          isModal={isModal ? isModal : ''}
                        />
                      </TabPane>
                      <TabPane tab={<GetLabel label="labels" />} key="8">
                        <AssetCatalogLabelsTable
                          asset={catalog ?? ([] as any)}
                          isModal={isModal ? isModal : ''}
                        />
                      </TabPane>
                      <TabPane tab={<GetLabel label="pictures" />} key="9">
                        <AssetCatalogPicturessTable
                          form={form}
                          catalogid={Number(id)}
                        />
                      </TabPane>
                      <TabPane
                        tab={<GetLabel label="assetCatalogRV" />}
                        key="10"
                      >
                        <AssetCatalogRVList
                          id={Number(id)}
                          asset={catalog ?? ([] as any)}
                          isModal={isModal ? isModal : ''}
                        />
                      </TabPane>
                      <TabPane tab={<GetLabel label="use" />} key="11">
                        <AssetUseList
                          catalogid={Number(id)}
                          asset={catalog ?? ({} as any)}
                          isModal={isModal ? isModal : ''}
                        />
                      </TabPane>
                      <TabPane tab={<GetLabel label="futurevalue" />} key="12">
                        <AssetFutureValueList
                          catalogid={Number(id)}
                          asset={catalog ?? ([] as any)}
                          isModal={isModal ? isModal : ''}
                        />
                      </TabPane>

                      <TabPane tab={<GetLabel label="manager" />} key="13">
                        <ProcessFollowUp
                          entity="CATALOG"
                          entityid={Number(id)}
                          entityReference={String(catalog?.catalogid) ?? ''}
                        />
                      </TabPane>
                      <TabPane
                        tab={<GetLabel label="Authorized Companies" />}
                        key="14"
                      >
                        <AssetCatalogAuthCompanies
                          catalogid={Number(catalog?.catalogid) ?? ''}
                          asset={catalog ?? ([] as any)}
                        />
                      </TabPane>
                    </>
                  )}
                </Tabs>
              )}
            </Form.Item>
          </div>
        </Form>
      </Spin>
    </DF.Provider>
  );
};

const INITIAL_VALUES: any = {
  assetCatalogComponents: [] as any,
  assetCatalogOptions: [] as any,
  assetCatalogServices: [] as any,
  entityAddAttribut: [] as any,
  assetDowngradeList: [] as any,
  assetUpgradeList: [] as any,
  deliverydelay: '',
  catalogidlinked: '' as any,
  catalogidlinkedlabel: '',
  assettaggrouping: '' as any,
  catalogidorigine: '' as any,
  catalogidoriginelabel: '',
  assetsegment: '',
  assetsegmentlabel: '',
  assetfamily: '',
  assetfamilylabel: '',
  assetcategory: '',
  assetcategorylabel: '',
  assetconstructor: '',
  assetconstructorreference: '',
  assetdescription: '',
  assetdiscountamount: 0,
  assetdiscountperc: 0,
  assetgrossamount: null as any,
  assetgrossamountorigine: null as any,
  assetlabel: '',
  assetmodel: '',
  assetmodellabel: '',
  assetmulticomponents: false,
  assetnetamount: 0,
  assetnetamountorigine: null as any,
  assetpictureurl: '',
  assetpictureurl2: '',
  assetpictureurl3: '',
  assetpictureurl4: '',
  assetpictureurl5: '',
  assetpictureurl6: '',
  assetstatuslabel: '',
  assettaxamount: 0,
  assettype: '',
  assettypelabel: '',
  assetvariant: '',
  assetversion: '',
  catalogid: 0,
  catalogstatus: 'INIT',
  enddate: '',
  flagwebshop: false,
  mcid: 0,
  mgid: '' as any,
  networkcode: '',
  startdate: '',
  suppliername: '',
  taxcode: '',
  taxrate: 0,
  tpidbroker: 0,
  tpidsupplier: 0,
  brokername: '',
  brokerreference: '',
  supplierreference: '',
  flagholdback: false,
  holdbackpercentage: 0,
  holdbackamount: 0,
  holdbackbeleasenbdays: 0,
  holdbackbeleasedate: '',
  kwhdegradation: 0,
  mclabel: '',
  kwhpower: 0,
  kwhproduction: 0,
  assetfinamount: 0,
  degfeesformula: '' as any,
  spfeesformula: '' as any,
  tpofformula: '' as any,
  power: '',
  weight: '',
  id: 0,
  tpidmanufacturer: 0,
  manufacturerreference: '',
  manufacturername: '',
};
export default AssetCatalogDetail;
